import { Stack } from '@mui/material';
import React, { ComponentType, ReactNode } from 'react';
import 'simplebar/dist/simplebar.min.css';
import { Footer } from 'src/components/footer';
import { Header, HeaderProps } from 'src/components/header';
import useStyles from './styles';

export const PageLayout: ComponentType<{ children: ReactNode } & HeaderProps> = ({
  children,
  ...headerProps
}) => {
  const classes = useStyles();

  return (
    <Stack className={classes.root} sx={{ minHeight: '100vh' }} justifyContent="space-between">
      <Header {...headerProps} />
      {children}
      <Footer />
    </Stack>
  );
};
